import { render } from "./AsSupportAuth.vue?vue&type=template&id=b31cd51e&scoped=true&ts=true"
import script from "./AsSupportAuth.vue?vue&type=script&lang=ts"
export * from "./AsSupportAuth.vue?vue&type=script&lang=ts"

import "./AsSupportAuth.vue?vue&type=style&index=0&id=b31cd51e&lang=scss&scoped=true"
import "./AsSupportAuth.vue?vue&type=style&index=1&id=b31cd51e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31cd51e"]])

export default __exports__